<script lang="ts" setup>
import { useStaticUrl } from "@/use/common";
import { Popup } from "vant";
import { store } from "@/composable/settings/theme";
import { useI18n } from "vue-i18n";
import chatTheme from "@/composable/settings/chatTheme";

const { t } = useI18n();
const themeConfig: {
  name: string;
  value: "dark" | "light" | "auto";
  icon: string;
}[] = [
  {
    name: t("SidebarNavi.dark"),
    value: "dark",
    icon: "icon-moon-light",
  },
  {
    name: t("SidebarNavi.light"),
    value: "light",
    icon: "icon-sun-light",
  },
  {
    name: t("SidebarNavi.auto"),
    value: "auto",
    icon: "icon-dark",
  },
];
const chatConfig: {
  name: string;
  value: "colorful" | "classic";
  previewUrl: string;
}[] = [
  {
    name: t("SidebarNavi.colorful"),
    value: "colorful",
    previewUrl: `${useStaticUrl("/settings/appearance/color.png")}`,
  },
  {
    name: t("SidebarNavi.classic"),
    value: "classic",
    previewUrl: `${useStaticUrl("/settings/appearance/classic.png")}`,
  },
];
</script>
<template>
  <div class="lg:pt-[var(--top-nav-height)]">
    <ThreadsNav :show-center="false" class="lg:hidden" show-back />
    <div class="flex flex-col gap-8 text-sm px-4">
      <div class="flex flex-col gap-4">
        <div class="font-bold text-lg">
          {{ $t("SidebarNavi.theme") }}
        </div>
        <div class="flex gap-2">
          <button
            v-for="item in themeConfig"
            :key="item.value"
            :class="store === item.value ? 'bg-primary text-white' : ''"
            class="border flex-1 p-2 rounded text-center font-bold"
            @click="store = item.value"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
      <div class="flex flex-col gap-4 py-2">
        <div class="font-bold text-lg">
          {{ $t("setting.chatTheme") }}
        </div>
        <div class="flex gap-2 text-sm">
          <div
            v-for="item in chatConfig"
            :key="item.value"
            :class="chatTheme === item.value ? 'btn-primary' : 'btn-neutral'"
            class="btn"
            @click="chatTheme = item.value"
          >
            <!--            <BaseImg :url="item.previewUrl" ratio="85:184" />-->
            {{ item.name }}
            <!--            <div-->
            <!--              class="absolute top-0 bottom-0 left-0 right-0 p-2 linear-background"-->
            <!--            >-->
            <!--              <div class="flex justify-between items-center">-->
            <!--                <div class="badge">{{ item.name }}</div>-->
            <!--                <check-circle-fill-icon-->
            <!--                  v-if="chatTheme === item.value"-->
            <!--                  class="icon-lg text-primary"-->
            <!--                />-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.linear-background {
  background: linear-gradient(rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 20%);
}
</style>
